import React from "react";

const logos = [
  { name: "Salesforce", src: "/assets/salesforce.png" },
  { name: "Greenhouse", src: "/assets/Greenhouse.png" },
  { name: "PitchBook", src: "/assets/Pitchbook.png" },
  { name: "Bloomberg", src: "/assets/Bloomberg.png" },
  { name: "Wealth Dynamix", src: "/assets/WDX.png" },
  { name: "ExperSoft", src: "/assets/Expersoft.png" },
  { name: "Gmail", src: "/assets/Gmail.png" },
  { name: "ZoomInfo", src: "/assets/zoominfo.png" },
  { name: "BambooHR", src: "/assets/BambooHR.png" },
  { name: "sharepoint", src: "/assets/sharepoint.png" },
];

function LogoItem({ logo }) {
  return (
    <div
      className="integration-tile flex-shrink-0"
      data-testid={`integration-logo-${logo.name.toLowerCase().replace(/\s/g, "-")}`}
      title={logo.name}
      aria-label={logo.name}
    >
      <img
        src={logo.src}
        alt={logo.name}
        className="integration-logo"
        loading="lazy"
      />
    </div>
  );
}

export default function IntegrationTicker() {
  const doubledLogos = [...logos, ...logos];

  return (
    <div className="overflow-hidden py-4" data-testid="integration-ticker">
      <div className="ticker-track">
        {doubledLogos.map((logo, i) => (
          <LogoItem key={`${logo.name}-${i}`} logo={logo} />
        ))}
      </div>
    </div>
  );
}
